import { Icon, ImageFallback, Shadow, Text, HStack, Stack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';
import { Box } from 'native-base';
import React from 'react';

interface ConsortiumDetailsProps {}

export const ConsortiumDetails: React.FC<ConsortiumDetailsProps> = () => {
  return (
    <VStack space={Spacing['inline.xxxs']}>
      <Text fontSize={Typography['fontsize.lg']} variant="semibold">
        Detalhes do consórcio
      </Text>
      <Box bg="neutral.lightest" h="0.5px" />
      <Shadow level={1} borderRadius={BoxRadius.sm}>
        <Stack
          direction={{ base: 'column', sm: 'row' }}
          p={Spacing['inline.xxs']}
          justifyContent="space-between"
          borderRadius={BoxRadius.sm}
          space={{ base: Spacing['stack.xxxs'], sm: 0 }}>
          <VStack flex={1} space={Spacing['inline.nano']}>
            <HStack space={Spacing['inline.nano']} alignItems="center">
              <Icon
                name={'Property' as IconographyTypes.Option}
                size="sm"
                color={Color['brand.tertiary.principal']}
              />
              <Text variant="semibold" fontSize={Typography['fontsize.xl']} color="neutral.black">
                Casa
              </Text>
            </HStack>
            <HStack alignItems="center" space={Spacing['inline.quarck']}>
              <Text color="neutral.dark">Valor da simulação:</Text>
              <Text variant="semibold" color="neutral.darkest">
                R$ 1.000.000,00
              </Text>
            </HStack>
          </VStack>
          <HStack space={Spacing['inline.xxxs']}>
            <ImageFallback src="" alt="image-consortium" width="30px" height="30px" />
            <VStack space={Spacing['inline.quarck']} flex={1}>
              <Text>Consórcio Genial</Text>
              <Text color="neutral.medium">Taxa de administração</Text>
            </VStack>
            <VStack space={Spacing['inline.quarck']} alignItems="flex-end">
              <HStack alignItems="center" space={Spacing['inline.quarck']}>
                <Text color="neutral.medium">219 x</Text>
                <Text variant="semibold" color="neutral.black">
                  R$ 5.662,10
                </Text>
              </HStack>
              <Text color="neutral.medium">24 %</Text>
            </VStack>
          </HStack>
        </Stack>
      </Shadow>
    </VStack>
  );
};
